export const initializeSearchBehavior = (searchId) => {
    const searchBar = document.getElementById(searchId);

    if (searchBar) {
        // Create spinner element
        const spinner = document.createElement("div");
        spinner.setAttribute("id", `spinner-${searchId}`);
        spinner.setAttribute("class", "flex justify-center p-4");
        spinner.innerHTML = `<div class="animate-spin rounded-full h-5 w-5 border-b-2 border-gray-900"></div>`;

        // Input handler
        searchBar.addEventListener("input", (e) => {
            const dropdown = document.querySelector(`#dropdown-${searchId}`);
            if (!searchBar.value && dropdown) {
                dropdown.innerHTML = '';
                dropdown.style.display = "none";
            } else if (searchBar.value && dropdown) {
                dropdown.innerHTML = '';
                dropdown.appendChild(spinner);
                dropdown.style.display = "block";
            }
        });

        // Results observer
        const resultsObserver = new MutationObserver((mutations) => {
            const dropdown = document.querySelector(`#dropdown-${searchId}`);
            mutations.forEach((mutation) => {
                if (mutation.addedNodes.length > 0 && 
                    Array.from(mutation.addedNodes).some(node => 
                        node.nodeType === 1 && 
                        (node.classList.contains('result-item') || 
                         node.classList.contains('no-result')))) {
                    const spinnerElement = document.querySelector(`#spinner-${searchId}`);
                    if (spinnerElement) {
                        spinnerElement.remove();
                    }
                    if (dropdown) {
                        dropdown.style.display = "block";
                    }
                }
            });
        });

        // Global click handler for this search instance
        const clickHandler = (e) => {
            const dropdown = document.querySelector(`#dropdown-${searchId}`);
            if (
                dropdown &&
                !searchBar.contains(e.target) &&
                !dropdown.contains(e.target)
            ) {
                dropdown.style.display = "none";
            }
        };

        // Focus handler
        searchBar.addEventListener("focus", (e) => {
            const dropdown = document.querySelector(`#dropdown-${searchId}`);
            if (dropdown && dropdown.children.length > 0 && searchBar.value) {
                dropdown.style.display = "block";
            }
        });

        // Blur handler
        searchBar.addEventListener("blur", (e) => {
            setTimeout(() => {
                const dropdown = document.querySelector(`#dropdown-${searchId}`);
                if (dropdown) {
                    dropdown.style.display = "none";
                }
            }, 150);
        });

        // Wait for autoComplete to create the dropdown
        const observerSetupInterval = setInterval(() => {
            const dropdown = document.querySelector(`#dropdown-${searchId}`);
            if (dropdown && !dropdown._observed) {
                resultsObserver.observe(dropdown, { 
                    childList: true,
                    subtree: true 
                });
                document.addEventListener("click", clickHandler);
                dropdown._observed = true;
                clearInterval(observerSetupInterval);
            }
        }, 50);

        // Clear interval after 2 seconds if dropdown hasn't been found
        setTimeout(() => clearInterval(observerSetupInterval), 2000);
    }
};